import { render, staticRenderFns } from "./TimelineNote.vue?vue&type=template&id=02fa4910&scoped=true&"
import script from "./TimelineNote.vue?vue&type=script&lang=js&"
export * from "./TimelineNote.vue?vue&type=script&lang=js&"
import style0 from "./TimelineNote.vue?vue&type=style&index=0&id=02fa4910&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fa4910",
  null
  
)

export default component.exports